import { Component } from '@angular/core'
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular'

import { UserProvider } from '../../providers/user/user'

import { Condominium, HousingUnit, User } from '../../models/models'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-user-add',
	templateUrl: 'user-add.html',
})
export class UserAddPage {
	public housingUnit: HousingUnit
	public condominium: Condominium

	public loading: any
	public isLoading: boolean

	//ruoli
	public is_operator: boolean

	public is_administrator: boolean
	public is_heatingreader: boolean
	public is_worker: boolean

	public is_resident: boolean
	public is_owner: boolean

	/**
	 Flag per generare il PIN quandop si aggiunge un nuovo utente, default: true
	*/
	public generatePin: boolean = true;

	constructor(
		/*
		private condominiums:CondominiumProvider,
		private housingUnits:HousingUnitProvider,
		*/
		private loadingCtrl: LoadingController,
		private navCtrl: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController,
		private users: UserProvider
	) {
		for(let permission of ['is_administrator', 'is_heatingreader', 'is_operator', 'is_worker', 'is_owner', 'is_resident']) {
			this[permission] = navParams.get(permission) ? true : false
		}
		this.condominium = navParams.get('condominium')
		this.housingUnit = navParams.get('housingUnit')
		this.generatePin = navParams.get('generatePin') ? true : false
	}

	add(user: User) {
		console.log("Si sta aggiungendo l'utente:", user)
		if(!user) {//nessun utente selezionato
			console.log('Nessun utente selezionato')
			let toast = this.toastCtrl.create({
				message: 'Nessun utente aggiunto',
				position: 'middle',
				duration: 3000,
				cssClass: "light"
			})
			toast.present()
			this.navCtrl.pop()
			return
		}

		let condominiumRoles = []
		let housingUnitRoles = []

		/*
		Aggiunge i permessi assegnati, senza modificare quelli eventualmente presenti
		*/
		let isUpdatingUser: boolean = false
		for(let role of ['is_administrator', 'is_heatingreader', 'is_operator', 'is_worker']) {
			if(this[role]) {
				switch(role) {
					case 'is_administrator':
					case 'is_heatingreader':
					case 'is_worker':
						if(this.condominium) {
							//aggiunge il permesso al condominio
							condominiumRoles.push(role)
							break
						} else {
							//aggiunge il permesso all'utente
							user[role] = true
							isUpdatingUser = true
						}
						break
					case 'is_operator'://aggiunge il permesso all'utente
						user[role] = true
						isUpdatingUser = true
						break
					case 'is_owner':
					case 'is_resident':
						if(this.housingUnit) {
							housingUnitRoles.push(role)
						}
						break
				}
			}
		}

		/*
		Dati utente per il feedback
		*/
		let type = null
		if(user.type == 'person') {
			type = 'Persona'
		} else if(user.type == 'company') {
			type = 'Azienda'
		} else {
			type = 'Utente di tipo sconosciuto'
		}

		let titles = ''
		if(this.is_administrator) {
			titles += ' amministratore'
		}
		if(this.is_heatingreader) {
			titles += ' termoletturista'
		}
		if(this.is_operator) {
			titles += ' gestore'
		}
		if(this.is_worker) {
			titles += ' addetto'
		}

		let fullname = user.name ? user.name : ''
		if(user.surname) {
			fullname += ' ' + user.surname
		}

		let isUpdating = isUpdatingUser || condominiumRoles.length > 0 || housingUnitRoles.length > 0
		if(isUpdating) {
			this.loading = this.loadingCtrl.create({
				content: 'Salvataggio in corso...',
				dismissOnPageChange: false
			})
			this.loading.present()
		}

		let updating = []
		if(isUpdatingUser) {
			//se ha modifiche da salvare aggiorna l'utente

			updating.push(new Promise((resolve, reject) => {
				this.users.update(user).then(user => {
					resolve(user)
				}).catch((error: any) => {
					reject(error)
				})
			}))
		}
		if(condominiumRoles.length > 0) {
			updating.push(new Promise((resolve, reject) => {
				this.users.addCondominiumRoles(user, this.condominium, condominiumRoles).then(pivot => {
					resolve(pivot)
				}).catch((error: any) => {
					reject(error)
				})
			}))
		}
		if(housingUnitRoles.length > 0) {
			updating.push(new Promise((resolve, reject) => {
				this.users.addHousingUnitRoles(user, this.housingUnit, condominiumRoles).then(pivot => {
					resolve(pivot)
				}).catch((error: any) => {
					reject(error)
				})
			}))
		}

		/*
		Fa partire tutte e aspetta l'ultima
		*/
		let self = this
		Promise.all(updating).then(function(updated) {//tutti sono ok
			self.loading.dismiss()
			let toast = self.toastCtrl.create({
				message: type + titles + ' "' + fullname + '" salvato "',
				position: 'middle',
				duration: 3000,
				cssClass: "light"
			})
			toast.present()
			self.navCtrl.pop()
		}).catch(error => {
			console.error("Errore salvando l'utente", error)
			let toast = self.toastCtrl.create({
				message: 'Errore salvando l\'utente',
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
			self.navCtrl.pop()
		})
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	ngAfterViewInit() {
		console.log('user-add page, generatePin: ' + (this.generatePin ? 'true' : 'false'))
	}
}



// WEBPACK FOOTER //
// ./src/pages/user-add/user-add.ts